// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e1ec4de5","498":"55ad0f84","545":"2da0fcf0"}[chunkId] + ".chunk.js";
};